import { IIconBase } from '..'

const profileAddIcon = ({
  color = '#ffffff',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.3337 13.5H9.66699'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11 14.8337V12.167'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.10673 7.74634C8.04006 7.73967 7.96006 7.73967 7.88673 7.74634C6.30006 7.69301 5.04006 6.39301 5.04006 4.79301C5.0334 3.15967 6.36006 1.83301 7.9934 1.83301C9.62673 1.83301 10.9534 3.15967 10.9534 4.79301C10.9534 6.39301 9.68673 7.69301 8.10673 7.74634Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.99336 15.0404C6.78003 15.0404 5.57336 14.7338 4.65336 14.1204C3.04003 13.0404 3.04003 11.2804 4.65336 10.2071C6.48669 8.98044 9.49336 8.98044 11.3267 10.2071'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default profileAddIcon
